import { render, staticRenderFns } from "./FromPhoneNumberVerification.vue?vue&type=template&id=5bc26471&"
import script from "./FromPhoneNumberVerification.vue?vue&type=script&lang=js&"
export * from "./FromPhoneNumberVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports